module.exports = __webpack_public_path__ + "static/part-5_ovr-bda1f04ec0902d96da225bc3306d25bf.svg";